export const createDirectionalStyles =
  (isRtl: boolean) =>
  (startValue: string | number, endValue: string | number, leftKey?: string, rightKey?: string) => ({
    [leftKey || 'left']: isRtl ? endValue : startValue,
    [rightKey || 'right']: isRtl ? startValue : endValue
  });

export const createDirectionalSpacing =
  (isRtl: boolean, spacingFn: (top: number, left: number, bottom: number, right: number) => string) =>
  (top: number, end: number, bottom: number, start: number) =>
    spacingFn(top, isRtl ? start : end, bottom, isRtl ? end : start);
